var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3228 24.0079L7.70213 20.9595L1.90539 23.271C1.46597 23.4939 1.03855 23.4764 0.623145 23.2187C0.207715 22.961 0 22.577 0 22.0668V3.77663C0 3.45075 0.0937016 3.16026 0.281105 2.90516C0.468508 2.65006 0.714224 2.46265 1.01825 2.34295L7.70213 0L16.3228 3.01559L22.0867 0.704041C22.5262 0.503089 22.9549 0.526012 23.3729 0.772809C23.791 1.01958 24 1.39807 24 1.90828V20.4279C24 20.7153 23.905 20.9634 23.715 21.1722C23.5249 21.381 23.2888 21.5343 23.0067 21.6321L16.3228 24.0079ZM15.2083 21.2595V4.87112L8.78381 2.70777V19.0961L15.2083 21.2595ZM17.175 21.2595L21.759 19.7503V3.12464L17.175 4.87112V21.2595ZM2.23317 20.8426L6.81712 19.0961V2.70777L2.23317 4.22484V20.8426Z",
    fill: "#1B544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/City.e357a5c15c598a9b2ae1a0255df7815f.svg";
export { ForwardRef as ReactComponent };